import { defineStore } from 'pinia';
import api from '@/services/api';
import {
  colores_filters,
  colores_model,
} from '../models/colores_model';
import { getParamsUrl } from '../colores_utils';

export const useColoresStore = defineStore('coloresStore', {
  state: () => ({
    entity: 'colores',
    colores: [],
    color: { ...colores_model },
    limit: 35,
    page: 1,
    filters: {},
    filtersVersion: 0,
  }),
  getters: {},
  actions: {
    async findAllColoresHTTP() {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ limit: this.limit, page: +this.page, ...this.filters })}`,
      );

      if (result && result.data && result.data.length > 0) {
        this.colores.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async saveColor() {
      const payload = {
        Descripcion: this.color.Descripcion,
        Hex: this.color.Hex,
        Pantone: this.color.Pantone,
      };
      if (this.color.Codigo) {
        return await this.updateColorHTTP(payload);
      }
      return await this.createColorHTTP(payload);
    },
    async createColorHTTP(payload) {
      return await api.post(`/${this.entity}`, payload);
    },
    async updateColorHTTP(payload) {
      return await api.patch(`/${this.entity}/${this.color.Codigo}`, payload);
    },
    async deleteColorHTTP(color) {
      await api.delete(`/${this.entity}/${color.Codigo}`);
      this.colores = this.colores.filter((c) => c.Codigo !== color.Codigo);
    },
    async searchColoresHTTP(q) {
      const { data } = await api.get(`/${this.entity}`, {
        params: {
          query: q,
          limit: 20,
          sortBy: 'Descripcion',
          sort: 'asc',
        },
      });
      return Array.isArray(data) ? data : [];
    },
    async getColorByCodigoHTTP(codigo) {
      const { data } = await api.get(`/${this.entity}/${codigo}`);
      return data && data.Codigo !== null ? data : null;
    },
    resetColor() {
      this.color = { ...colores_model };
    },
    resetFilters() {
      this.filters = { ...colores_filters };
    },
    setPage(page) {
      this.page = page;
    },
    async firstColores() {
      this.setPage(1);
      this.emptyList();
      await this.findAllColoresHTTP();
    },
    emptyList() {
      this.colores = [];
      this.filtersVersion++;
    },
  },
});
